import { Injectable } from '@angular/core';

import {
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError,
  ControlValidator,
  FileUploadFileTypeValidatorValue
} from '../../types/validator.types';

@Injectable()
export class FileUploadFileTypeControlValidator extends ControlValidator {
  type = ControlValidatorType.FileTypeOfUpload;
  validateMoment = ControlValidateMoment.Input;
  validate(): ControlValidatorError {
    this.error = new ControlValidatorError(false, '');
    const fileList = <Array<File>>this.control[`filesList`];
    if (!fileList || fileList.length === 0) {
      this.error.message = '';
      this.error.success = true;
      return this.error;
    }
    const fileTypes = this.getFileTypes();
    // è®¾ç½®fileç éªè¯éè¯¯ä¿¡æ¯
    fileList.forEach((file) => {
      let isValid = false;
      for (const type of fileTypes) {
        const regex = new RegExp(type);
        if (regex.test(file.name.toLocaleLowerCase())) {
          isValid = true;
          break;
        }
      }
      if (!isValid) {
        file[`validatorError`] = new ControlValidatorError(false, this.getErrorMsg());
      }
    });
    // è®¾ç½®å½åéªè¯å¨çéè¯¯ä¿¡æ¯
    let valid = true;
    fileList.forEach((file) => {
      if (file[`validatorError`] && !file[`validatorError`].success) {
        valid = false;
      }
    });
    if (!valid) {
      this.error.message = '';
      this.error.success = false;
    } else {
      this.error = new ControlValidatorError(true, '');
    }
    return this.error;
  }

  private getFileTypes(): string[] {
    if (!this.model) {
      return [];
    }
    const value = <FileUploadFileTypeValidatorValue>this.model;
    const types: string[] = [];
    if (value.hasDocument) {
      types.push(
        ...['.doc', '.docx', '.pdf', '.txt', '.xls', '.xlsx', '.ppt', '.pptx', '.rtf', '.xml', '.html', '.htm']
      );
    }
    if (value.hasImage) {
      types.push(...['.jp2', '.jpe', '.jpg', '.jpeg', '.svf', '.tif', '.tiff', '.png', '.gif', '.psd']);
    }
    if (value.hasCompressedPackage) {
      types.push(...['.rar', '.zip']);
    }
    return types;
  }

  private getErrorMsg(): string {
    let msg = 'ä»æ¯æ';
    const value = <FileUploadFileTypeValidatorValue>this.model;
    if (value.hasDocument) {
      msg += 'ææ¡£ï¼';
    }
    if (value.hasImage) {
      msg += 'å¾çï¼';
    }
    if (value.hasCompressedPackage) {
      msg += 'åç¼©åï¼';
    }
    msg = msg.substring(0, msg.length - 1);
    return msg;
  }
}
